module.exports = __webpack_public_path__ + "img/51.2.TN.8c04538d.png";